import { observer } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../../comps/OcDataview';
import { OcDataviewFiltering } from '../../../comps/OcDataviewFiltering';
import { PleaseWait } from '../../../comps/PleaseWait';
import { Submenu } from '../../../comps/Submenu';
import { useNoSubmenu } from '../../../mainpanel/useSubmenu';
import { useBooleanStateAgg } from '../../../mg/useStateAgg';
import { DataviewStore } from '../../../stores/DataviewStore';
import { useOmnistore } from '../../../stores/Omnistore';
import { AdmAdDialog } from './AdmAdDialog';

const dataviewStore = DataviewStore.create({
	id: 'AdmAdPage',
	orgColumns: [
		'id',
		'supplierName',
		'*name',
		'isDeleted :bool',
		'category :Advertisement_Category',
		'*validSince :datetime',
		'*validUntil :datetime',
		'badgeTitle',
		'badgeSubtitle',
		'*badgeColor',
		'imageLink',
		'*description',
		'viaTemplate :bool',
		// '*variations :object', //TODO
		'*amountStep :int',
		'*amountMax :int',
		'*oncePerBranch :bool',
		'nInitialItems :int',
		'supplierIdsAsString',
	],
	filtering: [{columns: ['supplierName'], value: '', type: 'SELECT'}, {columns: ['name']}, {columns: ['isDeleted'], type: 'BOOLEAN'}],
	sorting: {column: 'validSince', reversed: true},
});
dataviewStore.addColumnHiderToNamed('DEFAULT', 'category', 'badgeTitle', 'badgeSubtitle', 'badgeColor', 'imageLink',
	'description', 'viaTemplate', 'amountStep', 'amountMax', 'oncePerBranch', 'nInitialItems', 'supplierIdsAsString');

export const AdmAdPage = observer(function() {
	const showDialogAgg = useBooleanStateAgg();
	const omnistore = useOmnistore();
	const repo = omnistore.multirepo.admAdRepo;
	React.useEffect(() => {
		repo.fetch();
		omnistore.multirepo.publicSupplierRepo.fetch();
	}, []);

	function onDialogClose() {
		showDialogAgg.falseHandler();
		dataviewStore.rowClick(0);
	}
	const selectedEntity = repo.byId(dataviewStore.selectedEntityId);
	useNoSubmenu();
	return !repo.etag ? <PleaseWait/> : <>
		<Submenu>
			<OcDataviewFiltering state={dataviewStore} repo={repo}/>
			{{name: 'create', onClick: showDialogAgg.trueHandler}}
			---
		</Submenu>
		<OcDataview state={dataviewStore} repo={repo}/>
		{!showDialogAgg.value && !selectedEntity ? null : <AdmAdDialog onClose={onDialogClose} entity={selectedEntity}/>}
	</>;
});
